import { Typography, Box } from '@mui/material';

export default function ListBlock({ block }: { block: any }) {
    const renderListItems = () => {
        const items: React.ReactNode[] = [];

        for (let k = 0; k < block.items.length; k++) {
            const current = block.items[k];
            const next = block.items[k + 1];

            const mainText = typeof current === "string" ? current : current.text;
            const isBold = typeof current === "object" && current.bold;
            const isInset = typeof current === "object" && current.inset;
            const hasDescription = typeof next === "string";

            const listItemStyle = {
                marginLeft: isInset ? "2rem" : undefined,
                listStyle: typeof current === "object" && current.noStyle ? "none" : undefined,
            };

            if (hasDescription) {
                items.push(
                    <li key={k} style={listItemStyle}>
                        <span style={{ fontWeight: isBold ? "bold" : "normal" }}>{mainText}</span>
                        <Typography
                            component="div"
                            variant="body2"
                            sx={{
                                fontWeight: "normal",
                                fontSize: "0.95em",
                                opacity: 0.9,
                                mt: 0.5,
                                ml: 2,
                                lineHeight: 1.5,
                            }}
                        >
                        {next}
                        </Typography>
                    </li>
                    );
                    k++;
                } else {
                    items.push(
                    <li key={k} style={listItemStyle}>
                        <span style={{ fontWeight: isBold ? "bold" : "normal" }}>{mainText}</span>
                    </li>
                    );
                }
            }

        return items;
    };

    return (
        <Box
            component="ul"
            sx={{
                color: "white",
                mb: 3,
                px: 4,
                textAlign: "left",
                fontSize: "clamp(16px, 2vw, 22px)",
                "& li": {
                mb: 3,
                lineHeight: 1.6,
                listStyleType: "disc",
                },
            }}
        >
        {renderListItems()}
        </Box>
    );
}
